import { DashboardProfileView } from "@features/home-dashboard/components/DashboardProfileView";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/(dashboard)/profile/")({
  staticData: {
    title: "Mon Profil",
    section: "Général",
    order: 20,
    showInTab: true,
    showInBreadcrumb: true,
  },
  component: DashboardProfileRoute,
});

function DashboardProfileRoute() {
  return <DashboardProfileView />;
}
